<template>
  <v-simple-table v-if="data.length > 0">
    <template v-slot:default>
      <thead>
        <tr>
          <th v-for="event in getEventList" :key="event.year">
            {{ event.year }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="index in getMaxDateListLength" :key="index">
          <td v-for="event in getEventList" :key="event.year">
            <v-row align="center" justify="space-between" no-gutters>
              <v-row align="center" no-gutters>
                <div style="width: 20px;" class="mr-2">
                  <span class="caption">{{
                    getDayOfTheWeek(event, index)
                  }}</span>
                </div>
                <span v-if="getSales(event, index) > 0">{{
                  getSales(event, index)
                }}</span>
                <div v-else>
                  <v-icon x-small class="mr-1">fa-exclamation-circle</v-icon>
                  <span class="caption">Pas de données</span>
                </div>
                <span v-if="getSales(event, index) > 0" class="caption ml-1"
                  >$</span
                >
                <span v-else class="caption"></span>
              </v-row>
              <div
                v-if="
                  event.year !== getCurrentYear &&
                    getDelta(event, index) !== undefined
                "
              >
                <v-icon
                  small
                  left
                  color="success"
                  v-if="getDelta(event, index) > 0"
                >
                  fa-chevron-up
                </v-icon>
                <v-icon small left color="error" v-else>
                  fa-chevron-down
                </v-icon>
                <span
                  class="caption"
                  :style="{
                    color: getDelta(event, index) > 0 ? '#149911' : '#DE1A1A'
                  }"
                >
                  {{ Math.abs(getDelta(event, index)) }}
                  %</span
                >
              </div>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-row v-else align="center" justify="center">
    <v-icon small class="mr-1">fa-exclamation-circle</v-icon>
    <span>Pas de données pour l'évènement sélectionné</span>
  </v-row>
</template>

<script>
import { round10 } from "round10";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "AnalyticEventsGrid",
  props: {
    data: {
      type: Array,
      required: true
    },
    event: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getEvents"]),
    getEventList() {
      const list = this.getEvents.filter(x => x.name === this.event);
      return list.sort((a, b) => b.year - a.year);
    },
    getCurrentYear() {
      return String(Math.max(...this.getEventList.map(x => Number(x.year))));
    },
    getCurrentEvent() {
      return this.getEventList.find(x => x.year == this.getCurrentYear);
    },
    getYears() {
      return this.data.map(x => x.year);
    },
    getMergedSales() {
      const mergedSales = [];
      const group = this.data.map(x => {
        return x.sales;
      });
      group.forEach(x => {
        x.forEach(p => {
          mergedSales.push(p);
        });
      });
      return mergedSales;
    },
    getMaxDateListLength() {
      return Array.from(
        {
          length: Math.max(
            ...this.getEventList
              .map(x => this.getEventDateList(x))
              .map(x => x.length)
          )
        },
        (x, i) => i
      );
    }
  },
  methods: {
    getEventDateList(event) {
      const dates = [];

      let currDate = moment(event.start);
      const lastDate = moment(event.end);

      while (currDate.diff(lastDate) <= 0) {
        dates.push(currDate.clone().toDate());
        currDate.add(1, "days");
      }

      return dates;
    },
    getSales(event, index) {
      const eventDateList = this.getEventDateList(event);
      if (eventDateList.length >= index) {
        const eventDate = eventDateList[index];
        const sales = this.getMergedSales.find(x =>
          moment(x.date).isSame(moment(eventDate))
        );
        if (sales) {
          return sales.sales;
        } else {
          return 0;
        }
      }
    },
    getDelta(event, index) {
      const current = this.getSales(this.getCurrentEvent, index);
      const total = this.getSales(event, index);
      if (total > 0 && current > 0) {
        return round10(((current - total) / current) * 100, 0);
      } else {
        return undefined;
      }
    },
    formatDate(date) {
      return moment(date).format("MMMM DD");
    },
    getDayOfTheWeek(event, index) {
      const eventDateList = this.getEventDateList(event);
      if (eventDateList.length >= index) {
        const eventDate = eventDateList[index];
        return moment(eventDate).format("dd");
      } else {
        return "";
      }
    }
  }
};
</script>

<style></style>
